export const appuser_validaterepeatedpassword = [
  { name: "user_id", type: "guid", req: true },
  { name: "password", type: "password", req: true },
];
